import React, { useEffect, useState } from "react";
import SingleAssign from "./SingleAssign";
import BulkAssign from "../invite-applicant/BulkAssign";
import webservice_url from "../../../core/webservice/Webservice_url";
import { useParams } from "react-router";
import useApi from "../../../core/customhook/useApi";
import Loading from "../../../core/common/custom-loading/Loading";

export interface OrderFilterProps {
  organization: string;
  org_id?: string;
  project: string;
  project_id: string;
  location: string;
  program: string;
  program_id: string;
  package_id: string;
  department: string;
  department_id: string;
  package: string;
  package_description: string;
}

const initialData: OrderFilterProps = {
  organization: "",
  org_id: "",
  project: "",
  project_id: "",
  location: "",
  program: "",
  program_id: "",
  department: "",
  department_id: "",
  package: "",
  package_id: "",
  package_description: "",
};

const AssignOrderToCandidate = () => {
  const { orderId } = useParams();

  const [orderFilters, setOrderFilters] =
    useState<OrderFilterProps>(initialData);

  const [activeTab, setActiveTab] = useState("singleAssign");

  const { callApi, loading } = useApi<any>("", {
    method: "GET",
    autoCall: false,
    handleGlobalError: false,
  });

  useEffect(() => {
    const storedTab = localStorage.getItem("assign-order-tab");

    if (storedTab === "singleAssign" || storedTab === "bulkAssign") {
      setActiveTab(storedTab);
    }
  }, []);

  useEffect(() => {
    if (!orderId) return;

    const fetchData = async () => {
      try {
        const res = await callApi(
          undefined,
          `${webservice_url.getCheckOrderHierarchy}/${orderId}`,
        );
 
        const responseData = res?.data?.data ?? res?.data ?? res;

        const data = Array.isArray(responseData)
          ? responseData[0]
          : responseData;
 

        if (!data || typeof data !== "object") {
          console.error("Order hierarchy data was not found.");
          return;
        }

        const updatedFilters: OrderFilterProps = {
          organization: data.org_name ?? data.name ?? "",
          org_id: data.org_id ?? "",
          project: data.project_name ?? "",
          project_id: data.project_id ?? "",
          location: data.location_name ?? "",
          program: data.program_name ?? "",
          program_id: data.program_id ?? "",
          department: data.department_name ?? "",
          department_id: data.department_id ?? "",
          package: data.package_name ?? "",
          package_id: data.package_id ?? "",
          package_description: data.package_description ?? "",
        };
 
        setOrderFilters(updatedFilters);
 
      } catch (err) {
        console.error("Failed to fetch order hierarchy:", err);
      }
    };

    fetchData();
  }, [orderId]);

  const tabs = [
    {
      id: "singleAssign",
      label: "Single Applicant Invite",
      component: (
        <SingleAssign orderFilter={orderFilters} orderId={orderId} />
      ),
    },
    {
      id: "bulkAssign",
      label: "Bulk Invitations",
      component: (
        <BulkAssign orderFilter={orderFilters} orderId={orderId} />
      ),
    },
  ];

  const activeItem = tabs.find((item) => item.id === activeTab);
  const activeComponent = activeItem?.component ?? null;

  return (
    <div>
      {loading ? (
        <Loading />
      ) : (
        <>
          <ul className="nav nav-tabs p-2">
            {tabs.map((tab) => (
              <li className="nav-item mx-0" key={tab.id}>
                <button
                  type="button"
                  className={`nav-link rounded-0 ${
                    activeTab === tab.id
                      ? "active text-light bg-dark"
                      : "border border-dark"
                  }`}
                  onClick={() => {
                    setActiveTab(tab.id);
                    localStorage.setItem("assign-order-tab", tab.id);
                  }}
                >
                  {tab.label}
                </button>
              </li>
            ))}
          </ul>

          <div className="mt-4">{activeComponent}</div>
        </>
      )}
    </div>
  );
};

export default AssignOrderToCandidate;


// import React, { useEffect, useState } from "react";
// import SingleAssign from "./SingleAssign";
// import BulkAssign from "../invite-applicant/BulkAssign";
// import webservice_url from "../../../core/webservice/Webservice_url";
// import { useParams } from "react-router";
// import useApi from "../../../core/customhook/useApi";
// import Loading from "../../../core/common/custom-loading/Loading";

// export interface OrderFilterProps {
//   organization: string;
//   project: string;
//   location: string;
//   program: string;
//   package_id: string;
//   department: string;
//   package: string;
//   package_description: string;
//   project_id:string;
//   department_id:string;
//   program_id: string; 
// }

// const initialData = {
//   project_id:"",
//   department_id:"",
//   program_id: "",
//   organization: "",
//   project: "",
//   location: "",
//   program: "",
//   department: "",
//   package: "",
//   package_id: "", 
//   package_description: "",
// }

// const AssignOrderToCandidate = () => {
//   const { orderId } = useParams();
//   const [orderFilters, setOrderFilters] = useState<OrderFilterProps>(initialData);

//   const tabs = [
//     {
//       id: "singleAssign",
//       label: "Single Applicant Invite",
//       component: <SingleAssign orderFilter={orderFilters} orderId={orderId} />,
//     },
//     {
//       id: "bulkAssign",
//       label: "Bulk Invitations",
//       component: <BulkAssign orderFilter={orderFilters} orderId={orderId} />,
//     },
//   ];


//   const [activeTab, setActiveTab] = useState(tabs[0]?.id);
//   const activeItem = tabs.find((i) => i.id == activeTab);
//   const activeComponent = activeItem ? activeItem.component : <></>;

//   useEffect(() => {
//     const storedTab = localStorage.getItem("assign-order-tab") || null;
//     if (storedTab) {
//       setActiveTab(storedTab);
//     }
//   }, []);
 
//   const { callApi, loading } = useApi<any>("", {
//     method: "GET",
//     autoCall: false,
//     handleGlobalError: false,
//   });
 
//   useEffect(() => {
//     const fetchData = async () => {
//       try {
//         const res = await callApi(undefined, `${webservice_url.getCheckOrderHierarchy}/${orderId}`);
//         const data = res?.data?.[0] || null;
//         if (!data) return;
//         setOrderFilters((prev) => ({
//           ...prev,
//           organization: data?.org_name ?? "",
//           project: data?.project_name ?? "",
//           location: data?.program_name ?? "",
//           program: data?.program_name ?? "",
//           department: data?.department_name ?? "",
//           package: data?.package_name ?? "",
//           package_id: data?.package_id ?? "",
//           project_id: data?.project_id ?? "", 
//           program_id: data?.program_id ?? "", 
//           department_id: data?.department_id ?? "", 
//           package_description: data?.package_description ?? ""
//         }));
//       } catch (err: any) {
//         console.error(err)
//       }
//     }
//     if (!orderId) return;
//     fetchData()
//   }, [])

//   return (
//     <div>
//       {loading ? <Loading />
//         : <> 
//           <ul className="nav nav-tabs p-2">
//             {tabs.map((tab) => (
//               <li className="nav-item mx-0" key={tab.id}>
//                 <button
//                   className={`nav-link rounded-0 ${activeTab === tab.id ? "active text-light bg-dark" : "border border-dark"}`}
//                   onClick={() => {
//                     setActiveTab(tab.id);
//                     localStorage.setItem("assign-order-tab", tab.id);
//                   }}
//                 >
//                   {tab.label}
//                 </button>
//               </li>
//             ))}
//           </ul> 
//           <div className="mt-4 ">{activeComponent}</div> 
//         </>}
//     </div>
//   );
// };

// export default AssignOrderToCandidate;
